export type FormBuilderInteractionMode = 'builder' | 'rules' | 'view' | 'permissions';

export const isSelectionInteractionMode = (mode: FormBuilderInteractionMode | undefined): boolean =>
  mode === 'rules' || mode === 'permissions';
